import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { Cookie } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";

export const CookieBanner = () => {
  const { t } = useLanguage();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("cookie-consent")) {
      const timer = setTimeout(() => setShow(true), 900);
      return () => clearTimeout(timer);
    }
  }, []);

  const choose = (value) => {
    localStorage.setItem("cookie-consent", value);
    setShow(false);
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 24 }}
          transition={{ duration: 0.3 }}
          role="dialog"
          aria-modal="false"
          aria-label={t.cookie.title}
          data-testid="cookie-banner"
          className="fixed inset-x-3 bottom-3 z-40 rounded-2xl border border-warmline bg-white p-5 shadow-2xl sm:inset-x-auto sm:bottom-6 sm:left-6 sm:max-w-md"
        >
          <div className="flex items-start gap-3.5">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-teal-light text-teal">
              <Cookie className="h-5 w-5" aria-hidden="true" />
            </span>
            <div>
              <p className="font-display text-lg font-semibold text-petrol" data-testid="cookie-banner-title">
                {t.cookie.title}
              </p>
              <p className="mt-1.5 text-sm leading-relaxed text-slate2">{t.cookie.text}</p>
              <div className="mt-4 flex flex-wrap items-center gap-2.5">
                <button
                  data-testid="cookie-accept-all-button"
                  onClick={() => choose("all")}
                  className="rounded-full bg-teal px-4 py-2 text-xs font-semibold text-white transition-colors hover:bg-petrol"
                >
                  {t.cookie.acceptAll}
                </button>
                <button
                  data-testid="cookie-essential-only-button"
                  onClick={() => choose("essential")}
                  className="rounded-full border border-warmline px-4 py-2 text-xs font-semibold text-petrol transition-colors hover:border-teal hover:text-teal"
                >
                  {t.cookie.essentialOnly}
                </button>
                <Link
                  to="/datenschutz"
                  data-testid="cookie-privacy-link"
                  className="text-xs font-medium text-slate2 underline-offset-4 hover:text-teal hover:underline"
                >
                  {t.footer.privacy}
                </Link>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieBanner;
